<template>
  <div class="form-group boolean rwc_terms_consent">
    <div class="checkbox">
      <label
        class="program-consent-label"
        for="rugby-terms-consent-checkbox"
      >
        <input
          id="rugby-terms-consent-checkbox"
          v-model="acceptedRwcTermsConsent"
          class="rugby-terms-consent-checkbox"
          type="checkbox"
          name="rwc_terms_consent_checkbox"
          @change="updateRwcTermsConsent"
        >
        <span class="custom-checkbox" />
        <div class="terms-consent-text-wrapper">
          <!-- eslint-disable vue/no-v-html -->
          <span
            class="terms-consent-text"
            v-html="$t('creditCardForm.rwcTermsConsent')"
          />
          <!-- eslint-enable -->
        </div>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TermsConsentCheckbox',
  emits: ['update-rugby-world-cup-terms-consent'],
  data() {
    return {
      acceptedRwcTermsConsent: false
    }
  },
  methods: {
    updateRwcTermsConsent() {
      this.$emit('update-rugby-world-cup-terms-consent', this.acceptedRwcTermsConsent)
    }
  },
}

</script>
